import { Component, ChangeDetectionStrategy, ElementRef, AfterViewInit, OnInit } from '@angular/core';

import { Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { Store, select } from '@ngrx/store';

import { ModalButtons } from '@fcom/ui-components';

import { State, Modal } from '../../interfaces';
import { selectModalState } from '../../store/selectors';
import { ModalActions } from '../../store/actions';

@Component({
  selector: 'fin-upgrade-modal',
  templateUrl: 'modal.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UpgradeModalComponent implements OnInit, AfterViewInit {
  returnTarget: string;
  parentElement: HTMLElement;
  handlers: Modal['handlers'];
  openModal$: Observable<Modal & { open: boolean }>;

  constructor(
    private store: Store<State>,
    private element: ElementRef
  ) {}

  ngOnInit(): void {
    this.openModal$ = this.store.pipe(
      select(selectModalState),
      tap(({ returnTarget, modal }) => {
        this.returnTarget = returnTarget;
        this.handlers = modal?.handlers;
      }),
      map(({ modal }) => {
        return modal ? { ...modal, open: true } : { title: '', fragment: '', buttons: ModalButtons.DONE, open: false };
      })
    );
  }

  ngAfterViewInit(): void {
    this.parentElement = this.element.nativeElement?.parentElement;
  }

  closeModal(): void {
    const retTarget = this.returnTarget;
    this.returnTarget = null;
    this.store.dispatch(ModalActions.closeModal());
    if (this.handlers?.close) {
      this.handlers.close();
    }
    if (retTarget) {
      setTimeout(() => {
        this.parentElement.querySelector<HTMLButtonElement>(retTarget)?.focus();
      }, 10);
    }
  }

  confirmModal(): void {
    if (this.handlers?.confirm) {
      this.handlers.confirm();
    }
  }
}
